import Vue from 'vue'
import Vuex from 'vuex'
import { defaultNews } from '@/data/news'
import { navItems as defaultNavItems } from '@/data/site'
import { isAnqicmsEnabled, anqicmsConfig } from '@/config/anqicms'
import { fetchNavList, submitGuestbook } from '@/api/anqicms'
import { mapNavList } from '@/utils/nav'

Vue.use(Vuex)

const STORAGE_KEY = 'yuanma_news'
function loadNews() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      return JSON.parse(stored)
    }
  } catch (e) {
    console.warn('Failed to load news from localStorage')
  }
  return [...defaultNews]
}

function saveNews(news) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(news))
}

export default new Vuex.Store({
  state: {
    newsList: loadNews(),
    showRequirementDialog: false,
    navItems: null,
    navFromApi: false
  },
  getters: {
    getNewsById: state => id => {
      return state.newsList.find(item => item.id === Number(id))
    },
    sortedNews: state => {
      return [...state.newsList].sort((a, b) => new Date(b.date) - new Date(a.date))
    },
    headerNavItems: state => state.navItems || defaultNavItems,
    navFromApi: state => state.navFromApi
  },
  mutations: {
    SET_REQUIREMENT_DIALOG(state, visible) {
      state.showRequirementDialog = visible
    },
    ADD_NEWS(state, news) {
      const maxId = state.newsList.reduce((max, item) => Math.max(max, item.id), 0)
      state.newsList.unshift({
        ...news,
        id: maxId + 1,
        views: 0,
        date: news.date || new Date().toISOString().split('T')[0]
      })
      saveNews(state.newsList)
    },
    UPDATE_NEWS(state, news) {
      const index = state.newsList.findIndex(item => item.id === news.id)
      if (index !== -1) {
        Vue.set(state.newsList, index, { ...news })
        saveNews(state.newsList)
      }
    },
    DELETE_NEWS(state, id) {
      state.newsList = state.newsList.filter(item => item.id !== id)
      saveNews(state.newsList)
    },
    INCREMENT_VIEWS(state, id) {
      const item = state.newsList.find(n => n.id === Number(id))
      if (item) {
        item.views = (item.views || 0) + 1
        saveNews(state.newsList)
      }
    },
    SET_NAV_ITEMS(state, items) {
      state.navItems = items
      state.navFromApi = true
    }
  },
  actions: {
    openRequirementDialog({ commit }) {
      commit('SET_REQUIREMENT_DIALOG', true)
    },
    closeRequirementDialog({ commit }) {
      commit('SET_REQUIREMENT_DIALOG', false)
    },
    submitRequirement(_, form) {
      return submitGuestbook({
        user_name: form.name,
        contact: form.phone,
        companyName: form.company,
        email: form.email,
        content: form.description,
        position: form.jobTitle
      })
    },
    async loadNavigation({ commit }) {
      if (!isAnqicmsEnabled()) return

      try {
        const res = await fetchNavList({ type_id: anqicmsConfig.navTypeId })
        const list = mapNavList(res.data || [])
        if (list.length) {
          commit('SET_NAV_ITEMS', list)
        }
      } catch (e) {
        console.warn('导航 API 不可用，使用本地导航', e.message)
      }
    }
  }
})
